export default "__VITE_ASSET__Gy2dAF2z__"